export type AuthMeErrorCode =
  | "UNAUTHENTICATED"
  | "NOT_VERIFIED"
  | "FORBIDDEN"
  | "NEEDS_REGISTRATION";

export interface AuthMeOrg {
  orgId: string;
  role: string;
  status: string;
}

export interface AuthMeResponse {
  allowed: boolean;
  uid: string;
  email: string;
  emailVerified: boolean;
  globalRoles: string[];
  orgs: AuthMeOrg[];
  permissions: string[];
  needsTokenRefresh: boolean;
}

import { ApiClient, ApiError } from "../lib/api/baseClient";

export interface AuthMeError extends Error {
  code: AuthMeErrorCode;
  httpStatus: number;
}

// Create a dedicated client for auth/me calls
const authClient = new ApiClient();

export async function callAuthMe(
  _apiBaseUrl: string,
  token: string,
): Promise<AuthMeResponse> {
  try {
    authClient.setAuthToken(token);
    return await authClient.get<AuthMeResponse>("/auth/me");
  } catch (e) {
    // Keep backward-compatible error codes for existing auth flow.
    if (e instanceof ApiError) {
      const code = e.code as AuthMeErrorCode;
      if (
        code === "NOT_VERIFIED" ||
        code === "FORBIDDEN" ||
        code === "UNAUTHENTICATED" ||
        code === "NEEDS_REGISTRATION"
      ) {
        const err = new Error(code) as AuthMeError;
        err.code = code;
        err.httpStatus = e.httpStatus;
        throw err;
      }
    }
    throw e;
  }
}
